import { memo, useMemo } from "react";
import { motion } from "framer-motion";

import { useMountEffect } from "~/hooks/useMountEffect";

import { SHEET_MODAL_TRANSITION, useSheetModal } from "./SheetModal";

import type { HTMLMotionProps } from "framer-motion";

export const SheetModalBackdrop = memo(function SheetModalBackdrop() {
  const { backdropControls, requestClose } = useSheetModal();

  const motionProps = useMemo<Partial<HTMLMotionProps<"div">>>(() => {
    return {
      animate: backdropControls,
      exit: {
        opacity: 0,
        transition: SHEET_MODAL_TRANSITION,
      },
    };
  }, [backdropControls]);

  useMountEffect(() => {
    backdropControls?.start({
      opacity: 1,
      transition: SHEET_MODAL_TRANSITION,
    });
  });

  return (
    <motion.div
      {...motionProps}
      className="SheetModalBackdrop"
      onClick={requestClose}
    />
  );
});
